import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { SubMenu } from 'react-pro-sidebar';

import { FontAwesomeIcon } from '@hsp/react-component-library';
import { useUniqueKey } from '@hsp/react-hooks';
import { isDefined, isEmpty } from '@hsp/utilities';

import { useIsAccessible } from 'components/layouts/vertical/components/side-bar/hooks';
import { IMenuItem } from 'types/menu';

import NavItem from './nav-item';

const NavHeader: FC<IMenuItem> = (props) => {
  const { children, icon, path, title } = props;

  const isAccessible = useIsAccessible();
  const location = useLocation();
  const uniqueKey = useUniqueKey();

  if (!isAccessible(props)) {
    return null;
  }

  return (
    <SubMenu
      defaultOpen={location.pathname.includes(path)}
      icon={
        isDefined(icon) && !isEmpty(icon) ? (
          <FontAwesomeIcon
            icon={icon}
            size="1x"
          />
        ) : null
      }
      title={title}>
      {(children ?? []).map((element) => (
        <NavItem
          key={uniqueKey(element)}
          {...element}
        />
      ))}
    </SubMenu>
  );
};

export default NavHeader;
